var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.84 6.34a9.77 9.77 0 0 0-6-4.33V.87a.77.77 0 0 0-.41-.67.73.73 0 0 0-.79.08l-2.6 2a.75.75 0 0 0-.216.92.72.72 0 0 0 .216.26l2.6 2a.79.79 0 0 0 .79.08.77.77 0 0 0 .42-.68v-.78a7.84 7.84 0 0 1 4.3 3.32 1 1 0 0 0 1.38.32 1 1 0 0 0 .31-1.38zM9.89 20.899l-2.27-1.75c-.21-.17-.47-.34-.72-.24a.62.62 0 0 0-.32.62c.026.25.026.5 0 .75a7.66 7.66 0 0 1-4.46-3 2.2 2.2 0 0 0-.68-.74 1 1 0 0 0-1.43 1c.052.244.158.473.31.67a10 10 0 0 0 6.26 4.14c.026.306.026.614 0 .92a.73.73 0 0 0 .34.59c.27.12.51-.09.72-.25l2.18-1.68c.21-.15.43-.37.39-.62a.8.8 0 0 0-.32-.41zM10.871 2.54a2.5 2.5 0 0 0-3.54 0l-4.93 4.93a2.51 2.51 0 0 0 0 3.53l9.46 9.46a2.51 2.51 0 0 0 3.54 0l4.93-4.93a2.51 2.51 0 0 0 0-3.54l-9.46-9.45zm-.74 1.91 8.22 8.22a1 1 0 0 1 0 1.42l-4.41 4.41a1.001 1.001 0 0 1-1.42 0l-8.22-8.22a1 1 0 0 1 0-1.41l4.42-4.42a1 1 0 0 1 1.41 0z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenRotation);
export default __webpack_public_path__ + "static/media/screen-rotation.b73bdf9df63d81977dba8d2e81ef9962.svg";
export { ForwardRef as ReactComponent };